var map = {
	"./tapcoin/luckybox/box/1.png": 74891,
	"./tapcoin/luckybox/box/11.png": 30398,
	"./tapcoin/luckybox/box/2.png": 59330,
	"./tapcoin/luckybox/box/21.png": 87336,
	"./tapcoin/luckybox/box/3.png": 11363,
	"./tapcoin/luckybox/box/31.png": 16370,
	"./tapcoin/luckybox/box/4.png": 1188,
	"./tapcoin/luckybox/box/41.png": 85447,
	"./tapcoin/luckybox/box/5.png": 92037,
	"./tapcoin/luckybox/box/51.png": 51508,
	"./tapcoin/luckybox/box/6.png": 21910,
	"./tapcoin/luckybox/box/61.png": 90135
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3663;